import React from 'react';
import { graphql } from 'gatsby';
import LayoutContainer from '../../containers/layout';
import SEO from '../../components/seo';
import TextComponent from '../../components/TextComponent/textComponent';
import { BilateralContainerLayoutStyleListTypes, TextComponentLayout, getFeaturedContent, nonFeaturedContentFromList } from '../../utils/utils';
import BilateralContainerLayout from '../../components/Bilateral/BilateralContainerLayout/bilateralContainerLayout';
import './index.scss';
import getNewsData from '../../normalization/news';
import MediaContentBlock from '../../components/MediaContentBlock/mediaContentBlock';
import FeaturedContent from '../../components/FeaturedContent/featuredContent';

export const query = graphql`
  query NewsSitePageQuery {
    site: sanitySiteSettings(_id: { regex: "siteSettings/" }) {
      title
      description
      keywords
    }
  }
`;
const News = (props) => {
  const allNews = getNewsData().newsData;

  // this contains only featured news
  const featuredNews = getFeaturedContent(allNews);
  // this contains all blogs except for non-featured due to duplication
  const nonFeaturedBlogs = nonFeaturedContentFromList(allNews, featuredNews.id);
  const { data } = props;
  const { site } = data || {};
  return (
    <LayoutContainer>
      <SEO title={`${site.title} | News`} description={site.description} keywords={site.keywords} />
      <div className="news-wrapper">
        <BilateralContainerLayout layoutStyle={BilateralContainerLayoutStyleListTypes.BILATERALSTYLE5}>
          <div className="sorting-wrap">
            <TextComponent heading="Turfmutt News" layoutStyle={TextComponentLayout.LEFT} />
          </div>
          <FeaturedContent featuredData={featuredNews} />
        </BilateralContainerLayout>
        <div className="container">
          <div className="media-categories">
            <MediaContentBlock mediaData={nonFeaturedBlogs} dataLimit={6} isNews />
          </div>
        </div>
      </div>
    </LayoutContainer>
  );
};
export default News;
